import { toString } from 'lodash';
import { axios } from 'common/axios';

import {
  FortiCloudAccount,
  FortiCloudCommonData,
} from 'common/types/forticloud';

export const getFortiCloudData = async (): Promise<{
  content: {
    user_id: number;
    idp_name: string;
    user_email: string;
    selected_account_id_user_id: string;
    accounts_ids_users_ids_to_accounts_permissions: Record<
      string,
      {
        role_name: string;
        account_id: number;
        is_master_user: boolean;
        common_data: FortiCloudCommonData;
        user_display_info: { name: string; value: string }[];
      }
    >;
  };
}> => {
  const { data } = await axios.get('/api/forticloud');

  return data;
};

export const getFortiCloudAccounts = async (): Promise<{
  data: {
    relay_state: string;
    saml_response: string;
    forticloud_accounts: FortiCloudAccount[];
  };
}> => {
  const { data } = await axios.get('/api/forticloud/accounts');

  return data;
};

export const getFortiCloudAccountSelectionData = async (): Promise<{
  data: {
    idp_name: string;
    user_email: string;
  };
}> => {
  const { data } = await axios.get('/api/forticloud/account-selection');

  return data;
};

export const setSelectedAccountIdUserIdAuthenticated = async ({
  userId,
  accountId,
}: {
  userId: number;
  accountId: number;
  relayState?: string;
  samlResponse?: string;
}): Promise<void> => {
  const { data } = await axios.post('/api/forticloud/accounts', {
    user_id: userId,
    account_id: accountId,
  });

  return data;
};

export const setSelectedAccountIdUserIdNotAuthenticated = async ({
  userId,
  accountId,
  relayState,
  samlResponse,
}: {
  userId: number;
  accountId: number;
  relayState: string;
  samlResponse: string;
}): Promise<void> => {
  const params = new URLSearchParams();

  params.append('user_id', toString(userId));
  params.append('account_id', toString(accountId));

  if (relayState) {
    params.append('RelayState', relayState);
  }

  if (samlResponse) {
    params.append('SAMLResponse', samlResponse);
  }

  const { data } = await axios.post('/api/auth/saml2/acs/forticloud/', params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

  return data;
};
